import {
    IDatiqAnalyticsConfig,
    IDatiqAnalyticsEventTrack,
} from './datiq-analytics.interface';

import { emptyDatiqAnalytics } from './datiq-analytics-models-empty';

export class DatiqAnalyticsConfig implements IDatiqAnalyticsConfig {
    public trackingEvents?: IDatiqAnalyticsEventTrack[];
    public trackingPlanSheetId?: string;
    public segmentKey?: string;

    constructor() {
        this.trackingEvents = [...emptyDatiqAnalytics.trackingEvents];
        this.trackingPlanSheetId = '';
    }
}
